import eventMessage from 'src/components/event-message';
import { RESOURCE_TYPE } from 'src/constant';
import EVENT_MSG_TYPE from 'src/constant/event-msg-type';
import { win } from 'src/global';
import { IHBReqEvent } from 'src/types/type';
import { safetyResUrl } from 'src/utils';

const orgFetch = win.fetch;
export default function hbFetch(input: RequestInfo | URL, init?: RequestInit) {
  const hbReqEvent:IHBReqEvent = {
    _wait: true,
    m: (init?.method || 'get').toUpperCase(),
    rtype: RESOURCE_TYPE.XHR,
    rurl: safetyResUrl(input.toString()),
    txrs: Date.now(),
    _relativeTimeStart: performance.now(), // 开始点的相对时间值
    _reqBody: init?.body,
  };
  // 延时放入队列，避免早于点击事件
  setTimeout(() => {
    eventMessage.publish<IHBReqEvent>({
      time: hbReqEvent.txrs,
      type: EVENT_MSG_TYPE.FETCH,
      data: hbReqEvent,
    });
  }, 1);
  return orgFetch(input, init).then(res => {
    hbReqEvent.txre = Date.now();
    hbReqEvent.sat = res.status;
    hbReqEvent._relativeTimeEnd = performance.now(), // 结束点的相对时间值
    hbReqEvent._resHeaders = res.headers;
    return res;
  }).catch(err => {
    hbReqEvent.txre = Date.now();
    hbReqEvent._relativeTimeEnd = performance.now(), // 结束点的相对时间值
    hbReqEvent._err = err || 'error';
    hbReqEvent.msg = err?.toString() || 'unknown error';

    throw err;
  }).finally(() => {
    hbReqEvent._wait = false;
    if(hbReqEvent._onWaitBack) {
      hbReqEvent._onWaitBack();
    }
  });
}

export function wrapFetch() {
  // @ts-ignore
  if (!win.fetch.HBPROXY) {
    // @ts-ignore
    win.__hb_fetch = orgFetch;
    // @ts-ignore
    win.fetch = hbFetch;
  }
  // @ts-ignore
  hbFetch.HBPROXY = true;
}
